import MyDrawer from '../ui/Drawer';
import DateGridCalendar from '../calendar/date-calendar';

type Props = {
  isOpen: boolean;
  closeDrawer: () => void;
  title: string;
  onMonthDateChange: (month: number, year: number) => Promise<void>;
  onSelectDate: (date: Date) => void;
  selectedDate: Date | null;
  filteredDates?: Date[];
  openToDate?: Date;
};

const DateDrawer = ({
  isOpen,
  closeDrawer,
  title,
  onMonthDateChange,
  onSelectDate,
  selectedDate,
  filteredDates,
  openToDate,
}: Props) => {
  return (
    <MyDrawer isOpen={isOpen}>
      <div className="bg-additionalBlack">
        <div className="flex justify-between my-4">
          <p>{title}</p>
          <button onClick={closeDrawer} className="text-white">
            X
          </button>
        </div>
        {/* We unmount the calendar in order to make use of the openToDate prop */}
        {isOpen && (
          <DateGridCalendar
            onSelectDate={onSelectDate}
            selectedDate={selectedDate}
            filteredDates={filteredDates}
            onMonthDateChange={onMonthDateChange}
            openToDate={openToDate}
          />
        )}
      </div>
    </MyDrawer>
  );
};

export default DateDrawer;
